import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function ReparerPlutot() {
  return (
    <section className="bg-[#F4F8FB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Réparer plutôt que remplacer
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Avant de remplacer la sangle, nos techniciens vérifient toujours la cause exacte du dysfonctionnement. Parfois, le problème ne vient pas de la sangle elle-même, mais de l&apos;enrouleur bloqué, du guidage défectueux ou d&apos;un mauvais réglage de tension. Remplacer la sangle sans régler la cause sous-jacente conduirait à une nouvelle usure prématurée.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Nous inspectons l&apos;ensemble du mécanisme : l&apos;état de l&apos;enrouleur, le bon alignement du guidage, la fluidité des glissières du tablier et l&apos;absence de point dur. Si le problème vient d&apos;une pièce autre que la sangle, nous vous proposons la réparation adaptée pour une solution durable.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-8">
              Notre approche est simple : diagnostiquer avant d&apos;intervenir, pour ne remplacer que ce qui est nécessaire et vous éviter des frais inutiles. C&apos;est aussi cela notre engagement de réparateur professionnel à Strasbourg.
            </p>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Technician%20performing%20a%20detailed%20diagnostic%20inspection%20on%20a%20roller%20shutter%20strap%20mechanism%20using%20precision%20tools%20in%20a%20clean%20workshop%20environment%20bright%20lighting%20warm%20neutral%20tones%20professional%20service%20photography&width=700&height=520&seq=sang-diag&orientation=landscape" alt="Diagnostic d'une sangle de volet roulant à Strasbourg" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}